import React from 'react';

import { Footer, Header } from '../index';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <>
      <Header />
      <main id="mainContainer">{children}</main>
      <Footer />
    </>
  );
};
